module.exports = __webpack_public_path__ + "img/bn7.3b19605b.png";